import React, { useState } from 'react';
import { FiFilter, FiEdit, FiX  } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import Button from '../../../../../app/components/Button';
import Toast from '../../../../../app/components/Toast';
import Input from '../../../../../app/components/Input';
import EditRelevantRecord from '../../../../../../src/forms/FormsRecord/EditRelevantRecords';

const RegistroRelevantes = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  const [records, setRecords] = useState([
    {
      id: 1,
      enterprise: 'ODOS ACELERADORA LTDA',
      department: 'Marketing',
      responsible: 'João Silva, Maria Santos',
      channel: 'Telefone',
      record: 'Reunião sobre campanha de marketing digital.',
    },
    {
      id: 2,
      enterprise: 'ODOS ACELERADORA LTDA',
      department: 'Financeiro',
      responsible: ['Carlos Oliveira'],
      channel: 'E-mail',
      record: 'Envio de relatório financeiro trimestral.',
    },
  ]);

  const departmentOptions = [
    { value: 'marketing', label: 'Departamento Marketing', color: 'bg-yellow-500' },
    { value: 'financeiro', label: 'Departamento Financeiro', color: 'bg-purple-500' },
  ];

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const toggleFilter = () => setIsFilterOpen((prev) => !prev);

  const handleDepartmentSelect = (value) => {
    setSelectedDepartments((prev) =>
      prev.includes(value) ? prev.filter((d) => d !== value) : [...prev, value]
    );
  };

  const clearFilters = () => setSelectedDepartments([]);

  const handleOpenAddModal = () => {
    setSelectedRecord(null);
    setIsModalOpen(true);
  };

  const handleEditRecord = (record) => {
    setSelectedRecord(record);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRecord(null);
  };

  const showToast = (type, message) => {
    setToast({ show: true, type, message });
  };

  const handleSubmitRecord = (formData) => {
    try {
      if (formData.id) {
        setRecords((prev) =>
          prev.map((rec) => (rec.id === formData.id ? formData : rec))
        );
        showToast('success', 'Registro atualizado com sucesso!');
      } else {
        const nextId = Math.max(0, ...records.map((r) => r.id)) + 1;
        setRecords((prev) => [...prev, { ...formData, id: nextId }]);
        showToast('success', 'Novo registro adicionado com sucesso!');
      }
    } catch (error) {
      showToast('error', 'Erro ao salvar o registro.');
    } finally {
      handleCloseModal();
    }
  };

  const filteredDepartmentOptions = departmentOptions.filter((dept) =>
    dept.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredRecords = records.filter((record) => {
    const matchesDepartment =
      selectedDepartments.length === 0 ||
      selectedDepartments.includes(
        departmentOptions.find((d) => d.label.includes(record.department))?.value
      );

    const matchesSearch =
      !searchTerm ||
      record.enterprise.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (Array.isArray(record.responsible)
        ? record.responsible.join(', ').toLowerCase()
        : record.responsible.toLowerCase()
      ).includes(searchTerm.toLowerCase()) ||
      record.record.toLowerCase().includes(searchTerm.toLowerCase()) ||
      record.department.toLowerCase().includes(searchTerm.toLowerCase());

    return matchesDepartment && matchesSearch;
  });

  return (
    <div className="min-h-screen">
      {toast.show && (
        <Toast
          type={toast.type}
          message={toast.message}
          duration={3000}
          onClose={() => setToast({ ...toast, show: false })}
        />
      )}

      <div className="p-8">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-md font-medium text-gray-800">Departamento</h2>

          <div className="flex items-start space-x-3">
            <Button
              className="!h-10"
              onClick={handleOpenAddModal}
            >
              Adicionar
            </Button>

              <Input
                size='xs'
                label='Pesquisar'
                value={searchTerm}
                onChange={handleSearchChange}
              />

            <div
              className="text-gray-300 cursor-pointer mt-2 transition-colors duration-300 hover:text-[#a40ccb]"
              onClick={toggleFilter}
            >
              <FiFilter size={22}/>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          {filteredRecords.length > 0 ? (
            filteredRecords.map((record) => {
              const formattedResponsible = Array.isArray(record.responsible)
                ? record.responsible.join(', ')
                : record.responsible
                    .split(',')
                    .map((name) => name.trim())
                    .join(', ');

              const formattedRecordText = record.record
                ? record.record.charAt(0).toUpperCase() + record.record.slice(1).trim()
                : '';

              return (
                <div key={record.id} className="mb-6 bg-white border rounded-tr-2xl rounded-tl-2xl rounded-br-2xl">
                  <div className="flex p-4">
                    <div className="w-8 h-8 rounded-full bg-[#3f1057] flex items-center justify-center mr-3 flex-shrink-0">
                      <svg
                        className="w-4 h-4 text-white"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4.7l-8 5.334L4 8.7V6.297l8 5.333 8-5.333V8.7z" />
                      </svg>
                    </div>

                    <div className="flex-1">
                      <div className="flex justify-between items-center">
                        <h3 className="text-md font-medium text-gray-900 uppercase">odos aceleradora ltda</h3>
                        <Button
                          variant="secondary"
                          className="!px-3"
                          onClick={() => handleEditRecord(record)}
                        >
                          <FiEdit />
                        </Button>
                      </div>
                      <div className="flex text-sm text-gray-600 mt-1">
                        <span className="mr-6">Departamento: {record.department}</span>
                        <span className="mr-6">Responsável: {formattedResponsible}</span>
                        <span>Canal: {record.channel}</span>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 pb-4 pl-16">
                    <p className="text-sm text-gray-500 italic">{formattedRecordText}</p>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center py-12 text-gray-500">Nenhum registro encontrado</div>
          )}
        </div>
      </div>

      <AnimatePresence>
        {isFilterOpen && (
          <motion.div
            className="fixed top-20 right-[1.5rem] w-80 bg-white shadow-lg z-50 overflow-y-auto rounded-lg max-h-[500px]"
            initial={{ x: '100%', opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: '100%', opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          >
            <div className="p-4 border-b flex justify-between items-center">
              <h2 className="text-md font-medium">Filtrar cards</h2>
              <button
                className="text-gray-500 hover:text-gray-700"
                onClick={toggleFilter}
              >
                <FiX/>
              </button>
            </div>

            <div className="p-4 space-y-3">
              {filteredDepartmentOptions.map((dept) => (
                <button
                  key={dept.value}
                  className={`flex items-center space-x-2 w-full text-left px-2 py-1.5 rounded-md hover:bg-gray-100 transition-colors ${
                    selectedDepartments.includes(dept.value) ? 'bg-blue-50' : ''
                  }`}
                  onClick={() => handleDepartmentSelect(dept.value)}
                >
                  <div className={`w-4 h-4 rounded-full ${dept.color}`}></div>
                  <span className="text-gray-700 text-sm flex-1">{dept.label}</span>
                </button>
              ))}
              {filteredDepartmentOptions.length === 0 && (
                <div className="text-center py-6 text-gray-500">Nenhum departamento encontrado</div>
              )}

              {selectedDepartments.length > 0 && (
                <button
                  className="w-full mt-8 py-1 text-blue-600 border border-blue-600 rounded-md hover:bg-blue-50 transition-colors"
                  onClick={clearFilters}
                >
                  Limpar filtro
                </button>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <EditRelevantRecord
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={selectedRecord ? 'Editar Registro' : 'Adicionar Registro'}
        selectedRecord={selectedRecord}
        onSubmit={handleSubmitRecord}
      />
    </div>
  );
};

export default RegistroRelevantes;
